import api from '../../api.js';

export const SCHEME_ATTR = api.core.ns.attr('theme');
export const TRANSITION_ATTR = api.core.ns.attr('transition');
